import React, { useEffect, useState } from 'react';
import api from "../../../api";
import { Table, Pagination, Dropdown, Button } from 'antd';
import CompanyForm from "../Companies/Form/CompanyForm";

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    sorter: (a, b) => a.id - b.id,
    defaultSortOrder: 'ascend',
  },
  {
    title: 'Firma',
    dataIndex: 'title',
  },
  {
    title: 'Zweryfikowany',
    dataIndex: 'verified',
  },
  {
    title: 'Strona www',
    dataIndex: 'website',
  },
  {
    title: 'Telefon',
    dataIndex: 'phone',
  },
  {
    title: 'Ocena (Google)',
    dataIndex: 'googleRatings',
  },
  {
    title: 'Ilość ocen (Google)',
    dataIndex: 'googleRatingsAmount',
    defaultSortOrder: 'descend',
    sorter: (a, b) => a.googleRatingsAmount - b.googleRatingsAmount,
  },
  {
    title: 'Akcje',
    dataIndex: 'actions',
  },
];

const CompaniesScrapped = () => {
  const [allCompanies, setAllCompanies] = useState([]);
  const [companySearchParams, setCompanySearchParams] = useState({ title: '', sliderValue: '' });
  const [current, setCurrent] = useState(1);
  const companyPerPage = 20;

  const onPageChange = (page) => {
    setCurrent(page);
  };

  useEffect(() => {
    const getAllCompanies = async () => {
      let searchParams = {};
      if (companySearchParams.title) {
        searchParams = { search: `title:${companySearchParams.title}` };
      }

      let companies = await api.getCompaniesScrapped(searchParams);

      if (companySearchParams.sliderValue) {
        companies = companies.filter(company => company.statistic.googleRatings >= companySearchParams.sliderValue);
      }

      const data = companies.map(company => {
        const items = [
          {
            key: 'trails',
            label: <a target="_blank" href={`/super-admin/companies/${company.id}/trails`}>Trasy</a>
          },
          {
            key: 'preview',
            label: <a target="_blank" href={`/firmy/${company.slug}`}>Zobacz</a>
          },
          {
            key: 'edit',
            label: <a target="_blank" href={`/super-admin/companies/${company.id}/edit`}>Edytuj</a>
          },
          {
            key: 'delete',
            label: (
              <form
                style={{ display: 'inline' }}
                method="POST" action={`/super-admin/companies/${company.id}`}
                onClick={(e) => confirm('Na pewno usunąć? Akcja jest nieodwracalna') ? true : e.preventDefault()}
              >
                <input type="hidden" name="_method" value="delete" /> 
                <input type="hidden" name="_token" value={document.querySelector("[name=api-token]").content} />
                <button href="#" className="btn btn-sm btn-danger">Usuń</button>
              </form>
            )
          },
        ]
      
        return {
          key: company.id,
          id: company.id,
          title: company.title,
          phone: company.phone,
          website: company.website,
          verified: company.verified ? "Tak" : "Nie",
          googleRatings: company.statistic.googleRatings || "-",
          googleRatingsAmount: company.statistic.googleUserRatingsTotal || "-",
          actions: (
            <Dropdown menu={{ items }}>
              <Button>Akcje</Button>
            </Dropdown>
          )
        }
    });

      setAllCompanies(data);
    }

    getAllCompanies();

  }, [companySearchParams]);

  const totalCompanies = allCompanies.length;
  const totalPages = Math.ceil(totalCompanies / companyPerPage);

  const firstCompanyIndex = (current - 1) * companyPerPage;
  const lastCompanyIndex = current * companyPerPage;
  //now there are companies to show after pagination on
  const companiesOnPage = allCompanies.slice(firstCompanyIndex, lastCompanyIndex);

  const searchCompany = (searchingParams) => {
    setCompanySearchParams(searchingParams);
  }

  const clearSearchParams = () => {
    setCompanySearchParams({ title: '', sliderValue: '' });
  }

  return (
    <>
      <h1>Lista firm (scrapped)</h1>
      <CompanyForm searchHandler={searchCompany} searchParams={companySearchParams} clearParams={clearSearchParams} />
      <Table columns={columns} dataSource={companiesOnPage} pagination={false} />
      <Pagination current={current} onChange={onPageChange} total={totalPages * 10} />
    </>
  )
}

export default CompaniesScrapped;
